import { Text } from "@radix-ui/themes";

import { getBlockKey } from "../blockKey";
import { CanvasBlockRenderer } from "../CanvasBlockRenderer";
import { type CanvasBlock } from "../types";

interface SectionBlockProps {
  id: string;
  title: string;
  children: CanvasBlock[];
  onSectionClick?: (sectionId: string, title: string) => void;
}

export function SectionBlock({
  id,
  title,
  children,
  onSectionClick,
}: SectionBlockProps) {
  return (
    <div id={`canvas-section-${id}`} className="group space-y-2">
      <div className="flex min-h-[24px] items-center justify-between">
        <Text
          as="p"
          size="3"
          weight="bold"
          className="text-puntt-neutral-gray-12"
        >
          {title}
        </Text>
        {onSectionClick && (
          <button
            onClick={() => onSectionClick(id, title)}
            className="ml-2 shrink-0 cursor-pointer rounded px-2 py-0.5 text-xs text-puntt-accent-9 opacity-0 transition-opacity duration-150 hover:bg-puntt-accent-2 focus:bg-puntt-accent-2 focus:opacity-100 focus:outline-none focus:ring-2 focus:ring-puntt-accent-9 group-hover:opacity-100"
          >
            Ask about this
          </button>
        )}
      </div>
      {children?.length > 0 && (
        <div className="space-y-2 pl-1">
          {children.map((child, idx) => (
            <CanvasBlockRenderer key={getBlockKey(child, idx)} block={child} />
          ))}
        </div>
      )}
    </div>
  );
}
